import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    SelectField,
    SelectOption,
    toast
} from '@7shifts/sous-chef';
import { __ } from 'i18n/translate';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { FeatureFlag } from 'adminPanel/types';
import { useState } from 'react';
import { assignFeatureFlag } from 'adminPanel/api/companies';
import { handleError } from 'api/apiUtils';

type Props = {
    onClose: () => void;
    assignedFeatures: FeatureFlag[];
    companyId: number;
    onSuccess: () => void; // Optional callback for success
};
const AddCompanyFeatureModal = ({
    onClose,
    assignedFeatures,
    companyId,
    onSuccess
}: Props) => {
    const { featureFlags } = useFeatureFlags();
    const assignedFeatureKeys = assignedFeatures.map((feature) => feature.key);
    const options = featureFlags
        .filter((flag) => !assignedFeatureKeys.includes(flag.key))
        .map((flag) => ({
            value: flag.id,
            label: flag.key
        }));
    const [selectedOption, setSelectedOption] =
        useState<SelectOption<number>>();

    const [isAssigning, setIsAssigning] = useState(false);

    const handleAddFeature = () => {
        if (!selectedOption) return;
        setIsAssigning(true);
        assignFeatureFlag(companyId, selectedOption.value)
            .then(() => {
                toast(__('adminpanel.featureFlagAssigned'));
                onSuccess();
                onClose();
            })
            .catch(handleError)
            .finally(() => {
                setIsAssigning(false);
            });
    };

    return (
        <Modal header={__('adminpanel.addFeatureFlag')} onClose={onClose}>
            <ModalBody>
                <SelectField
                    name="featureFlag"
                    label={__('adminpanel.featureFlag')}
                    placeholder={__('adminpanel.selectFeatureFlag')}
                    options={options}
                    onChange={setSelectedOption}
                />
            </ModalBody>
            <ModalFooter
                actions={{
                    primary: (
                        <Button
                            disabled={!selectedOption}
                            onClick={handleAddFeature}
                            loading={isAssigning}
                        >
                            {__('adminpanel.addFeatureFlag')}
                        </Button>
                    ),
                    secondary: (
                        <Button onClick={onClose}>{__('main.cancel')}</Button>
                    )
                }}
            />
        </Modal>
    );
};

export default AddCompanyFeatureModal;
